import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  has,
  isEmpty,
  reduce,
} from 'lodash';
import ProviderMap from '../ProviderMap';
import { formatAddress, formatPhoneNumber, formatEmail } from '../../utils';
import {
  IconClock,
  IconMail,
  IconMarker,
  IconPhone,
} from '../Icons';
import HoursOfOperation from '../HoursOfOperation';

class ProviderModal extends Component {
  constructor(props) {
    super(props);
    this.onEscPress = this.onEscPress.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onEscPress);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onEscPress);
  }

  onEscPress(event) {
    if (get(event, 'key') === 'Escape') {
      const { onModalClose } = this.props;
      onModalClose();
    }
  }

  onPrint() {
    const elements = document.getElementsByClassName('uu-provider-modal__content');
    const content = get(elements, '[0].outerHTML', '');
    const { styleSheets } = document;
    const styles = reduce(styleSheets, (acc, styleSheet) => {
      try {
        const { cssRules } = styleSheet;
        const stylesText = reduce(cssRules, (ac, rule) => (
          [...ac, get(rule, 'cssText', '')]
        ), []);
        return [...acc, ...stylesText];
      } catch (e) { return acc; }
    }, []).join('\n');

    const newWindow = window.open();
    newWindow.document.write('<style>');
    newWindow.document.write(styles);
    newWindow.document.write('</style>');
    newWindow.document.write('<div class="uu-provider-modal">');
    newWindow.document.write(content);
    newWindow.document.write('</div>');

    newWindow.print();
    newWindow.close();
  }

  render() {
    const {
      onModalClose,
      provider,
    } = this.props;

    const hasAddress = has(provider, 'addresses[0]');
    const hasPhone = !isEmpty(provider.phone_numbers);
    const hasEmail = !isEmpty(provider.email_addresses);
    const hasHoursOfOperation = !isEmpty(provider.hours_of_operation);

    return (
      <div className="uu-provider-modal">
        <div className="uu-provider-modal__backdrop" />
        <div className="uu-provider-modal__window">
          <div className="uu-provider-modal__header">
            <button
              className="uu-provider-modal__print-btn"
              type="button"
              onClick={this.onPrint}
            >
              Print
            </button>
            <button
              className="uu-provider-modal__close-btn"
              type="button"
              onClick={onModalClose}
            >
              Close
            </button>
          </div>
          <div className="uu-provider-modal__content">
            <ProviderMap
              provider={provider}
            />
            <h5>
              {provider.name}
            </h5>
            <div
              className="uu-provider-modal__description"
              dangerouslySetInnerHTML={{ __html: provider.description } /* eslint-disable-line */}
            />
            {
              hasAddress && (
                <div className="uu-provider-modal__address">
                  <IconMarker />
                  <span>
                    {formatAddress(get(provider, 'addresses[0]'))}
                  </span>
                </div>
              )
            }
            {
              hasPhone && (
                <div className="uu-provider-modal__phone">
                  <IconPhone />
                  <span className="uu-provider-modal__phone-number">
                    {formatPhoneNumber(provider.phone_numbers)}
                  </span>
                </div>
              )
            }
            {
              hasHoursOfOperation && (
                <div className="uu-provider-modal__hoo">
                  <IconClock />
                  <HoursOfOperation
                    hours={provider.hours_of_operation}
                  />
                </div>
              )
            }
            {
              hasEmail && (
                <div className="uu-provider-modal__email">
                  <IconMail />
                  <a
                    href={`mailto:${formatEmail(provider.email_addresses)}`}
                  >
                    {formatEmail(provider.email_addresses)}
                  </a>
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

ProviderModal.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  provider: PropTypes.object.isRequired,
};

export default ProviderModal;



// WEBPACK FOOTER //
// ./public/js/components/ProviderModal/index.jsx